import type { ReactElement, ReactNode } from "react";
import { Ctext } from "../Ctext";
import { TextPreset } from "@/constants/componentPresets";
import { TOOLTIP_BODY_SIZE, TOOLTIP_TEXT_OPACITY } from "./ctooltip-constants";

interface CtooltipBodyProps {
  body: ReactNode;
}

export function CtooltipBody({ body }: CtooltipBodyProps): ReactElement {
  if (typeof body === "string") {
    return (
      <Ctext
        preset={TextPreset.Mild}
        size={TOOLTIP_BODY_SIZE}
        opacity={TOOLTIP_TEXT_OPACITY}
      >
        {body}
      </Ctext>
    );
  }

  return <>{body}</>;
}
